export var PdfViewerPendoTrackEventName;
(function (PdfViewerPendoTrackEventName) {
    PdfViewerPendoTrackEventName["SearchAvailability"] = "PDF Viewer - Search availabilty";
    PdfViewerPendoTrackEventName["ShowSearch"] = "PDF Viewer - Show search";
    PdfViewerPendoTrackEventName["HideSearch"] = "PDF Viewer - Hide search";
    PdfViewerPendoTrackEventName["GoToNextSearchResultPage"] = "PDF Viewer - Go to the next search result page";
    PdfViewerPendoTrackEventName["GoToPreviousSearchResultPage"] = "PDF Viewer - Go to the previous search result";
    PdfViewerPendoTrackEventName["SearchResults"] = "PDF Viewer - Search results";
})(PdfViewerPendoTrackEventName || (PdfViewerPendoTrackEventName = {}));
export class PdfViewerSearchAvailabiltyPendoTrackEvent {
    constructor(metadata) {
        this.metadata = metadata;
        this.name = PdfViewerPendoTrackEventName.SearchAvailability;
    }
}
export class PdfViewerShowSearchPendoTrackEvent {
    constructor(metadata) {
        this.metadata = metadata;
        this.name = PdfViewerPendoTrackEventName.ShowSearch;
    }
}
export class PdfViewerHideSearchPendoTrackEvent {
    constructor(metadata = {}) {
        this.metadata = metadata;
        this.name = PdfViewerPendoTrackEventName.HideSearch;
    }
}
export class PdfViewerGoToNextSearchResultPagePendoTrackEvent {
    constructor(metadata) {
        this.metadata = metadata;
        this.name = PdfViewerPendoTrackEventName.GoToNextSearchResultPage;
    }
}
export class PdfViewerGoToPreviousSearchResultPagePendoTrackEvent {
    constructor(metadata) {
        this.metadata = metadata;
        this.name = PdfViewerPendoTrackEventName.GoToPreviousSearchResultPage;
    }
}
// we could add some stuff here like the number of results?
export class PdfViewerSearchResultsPendoTrackEvent {
    constructor(metadata) {
        this.metadata = metadata;
        this.name = PdfViewerPendoTrackEventName.SearchResults;
    }
}
//# sourceMappingURL=pdf-viewer-pendo-track-event.type.js.map